// 150 témoignages style Google Avis pour Maître Diamma
// Structure: { nom, ville, texte, note, il_y_a }

const noms = [
  "Sophie L.","Karim B.","Nadia R.","Jean-Marc D.","Aïcha M.","Élodie F.",
  "Mehdi T.","Christelle P.","Ibrahim S.","Valérie C.","Fatou D.","Kevin M.",
  "Marion V.","Youssef A.","Sabrina N.","Thierry G.","Amina K.","Nicolas H.",
  "Émilie B.","Rachid E.","Céline J.","Mamadou C.","Ludivine T.","Farid Z.",
  "Aurélie R.","Djamel O.","Priscilla L.","Bruno S.","Nawel B.","Jordan P.",
  "Chloé D.","Samir H.","Isabelle F.","Karima L.","Damien A.","Laura M.",
  "Abdel K.","Justine B.","Anthony T.","Meriem S.","Sébastien V.","Léa G.",
  "Omar F.","Nathalie D.","Adrien C.","Kadidia S.","Cédric M.","Lucie P.",
  "Hakim J.","Émeline B.","Fabien R.","Souad A.","Julien L.","Céline V.",
  "Mounir T.","Charlotte S.","Yanis D.","Amandine G.","Tarik B.","Angélique R.",
  "Idriss K.","Manon C.","Anthony L.","Kenza M.","Yohan P.","Sonia B.",
  "Loïc D.","Nassima F.","Vincent T.","Awa S.","Alexandre G.","Camille R.",
  "Sami E.","Émeline B.","Alicia P.","Malik D.","Vanessa C.","Éric M.",
  "Sarah H.","Franck B.","Amel R.","Antoine S.","Djénéba F.","Corinne L.",
  "Rayan T.","Sandrine V.","Jérôme M.","Lila D.","Marc-Antoine B.","Fanny G.",
  "Mehdi K.","Ophélie C.","Boubacar N.","Jessica R.","Bilal S.","Estelle T.",
  "Hicham B.","Marilyne D.","Steven P.","Kadi F.","Théo M.","Assia H.",
  "Grégory L.","Selma C.","Xavier B.","Hafsa T.","Guillaume R.","Wafa D.",
  "Frédéric M.","Nawel S.","Pauline B.","Djibril G.","Cyril H.","Ines P.",
  "Christophe D.","Mounira A.","Kevin F.","Djennifer T.","Riad B.","Océane M.",
  "Jean-Baptiste S.","Malika R.","Simon C.","Alicia D.","Youcef P.","Roxane V.",
  "Cheikh G.","Béatrice B.","Djibril L.","Marilou T.","Zakaria F.","Charlène S.",
  "Ilyas M.","Sylvie D.","Yassine C.","Léna B.","Aziz T.","Hélène G.",
  "Karim P.","Sabrina M.","Anas R.","Delphine C.","Moussa B.","Solène L.",
  "Anaïs H.","Wassim D.","Mariam S.","Grégoire T."
];

const villes = [
  "Orléans","Orléans","Orléans","Fleury-les-Aubrais","Saran","Olivet","Saint-Jean-de-Braye",
  "Saint-Jean-de-la-Ruelle","La Chapelle-Saint-Mesmin","Ingré","Saint-Jean-le-Blanc","Chécy",
  "Saint-Denis-en-Val","Saint-Cyr-en-Val","Montargis","Gien","Pithiviers","Meung-sur-Loire",
  "Beaugency","Jargeau","Châteauneuf-sur-Loire","Amilly","Sully-sur-Loire","La Ferté-Saint-Aubin",
  "Blois","Tours","Chartres","Vierzon","Bourges","Paris","Orléans","Olivet","Fleury-les-Aubrais","Saran","Orléans"
];

const textes = [
  "Après trois mois de séparation, mon compagnon est revenu vers moi. Je n'y croyais plus. Maître Diamma a été d'une écoute exceptionnelle.",
  "Un homme droit, sincère. Il ne promet pas la lune, il agit avec précision. Je le recommande sans aucune hésitation.",
  "Ses rituels ont apporté la paix chez nous. Mon mari a changé de comportement en quelques semaines. Merci infiniment.",
  "J'avais perdu confiance en tout. Maître Diamma m'a redonné foi en la vie et en moi-même. Résultats concrets et rapides.",
  "Discret, professionnel, à l'écoute. Sa voyance a été d'une précision impressionnante. Je reviendrai sans hésiter.",
  "Rituel de retour affectif : mon ex m'a rappelée dans les 10 jours. Aujourd'hui nous sommes plus unis que jamais.",
  "Un vrai marabout, pas un charlatan. Il vous dit franchement ce qu'il peut faire, et il fait ce qu'il dit.",
  "Désenvoûtement complet réalisé, je me sens libérée d'un poids que je portais depuis des années.",
  "Consultation téléphonique au top. Il a vu des détails de ma vie personne ne pouvait connaître. Bluffant.",
  "Grâce à lui, j'ai décroché le poste dont je rêvais depuis 2 ans. Un homme aux dons incroyables.",
  "Mes affaires vont enfin décoller. Chiffre d'affaires doublé en 3 mois après son intervention.",
  "Protection installée pour ma famille. Depuis, plus de conflits, plus de mauvaises ondes à la maison.",
  "Ma fille traversait une période difficile. Après un soin de Maître Diamma, elle a retrouvé sourire et sérénité.",
  "Sa bienveillance transperce dès le premier appel. On sent une âme profondément juste et pleine de sagesse.",
  "Je pensais avoir tout essayé. Maître Diamma a réussi là où d'autres ont échoué. Résultats bien réels.",
  "Réconciliation avec mon mari après des mois de tensions. Aujourd'hui l'amour est plus fort qu'à nos débuts.",
  "Une voyance juste, précise, sans blabla. Il va droit à l'essentiel. Merci pour ces réponses claires.",
  "L'homme que j'aime est revenu me chercher, en larmes. Il ne comprenait pas ce qui lui arrivait. Effet garanti.",
  "Confidentiel de A à Z. Aucune indiscrétion. Un professionnel authentique et respectueux.",
  "J'étais sceptique au départ. Aujourd'hui je suis reconnaissante pour tout ce qu'il a fait pour ma famille.",
  "Ses tarifs sont adaptés à chaque situation. Il prend le temps qu'il faut, sans compter.",
  "Mon insomnie chronique a disparu après un soin énergétique. Je dors enfin comme un bébé.",
  "Il m'a aidée à sortir d'une relation toxique qui me détruisait. Aujourd'hui je respire, je revis.",
  "Rituel de chance efficace : j'ai gagné aux jeux et signé un contrat majeur la même semaine.",
  "Mon fils a repris ses études après un long décrochage. Maître Diamma a débloqué ce qui devait l'être.",
  "Séance de désenvoûtement puissante. J'ai littéralement senti un poids quitter ma poitrine.",
  "Une écoute rare dans ce milieu. Il ne juge pas, il ne culpabilise pas. Il agit avec cœur.",
  "Retour affectif réussi en moins de 4 semaines. Mon fiancé est rentré, on se marie l'année prochaine.",
  "Ses prédictions se sont réalisées mot pour mot. Une précision qui donne des frissons.",
  "Attirance renouvelée entre mon compagnon et moi. Notre couple a retrouvé son étincelle.",
  "Je consultais à distance depuis Paris. Résultats identiques à une consultation en cabinet.",
  "Mon entreprise était au bord de la faillite. Après ses travaux spirituels, tout s'est débloqué.",
  "Une expérience qui change une vie. Maître Diamma est un grand monsieur, respectueux et efficace.",
  "Mon mari trompeur est revenu à la raison. Il m'implore de rester avec lui. Puissance ancestrale.",
  "Après le décès de mon père, j'ai retrouvé la paix intérieure grâce à ses soins.",
  "Rituel d'attraction amoureuse : j'ai rencontré l'homme de ma vie 3 semaines plus tard.",
  "Il ne cherche pas à vous garder pour vous vendre autre chose. Il travaille, on paie, on avance.",
  "Ma belle-mère toxique nous laisse enfin en paix. Merci Maître pour cette délivrance.",
  "Mes examens ont été réussis haut la main après un rituel de chance. Je vais entamer mon master.",
  "Grâce à ses conseils, j'ai évité un mariage désastreux. Il m'a montré la vraie nature de cet homme.",
  "Blocages financiers levés. L'argent circule à nouveau dans ma vie. Mille mercis.",
  "Sa voix apaise déjà. On se sent en sécurité, entendu, jamais jugé.",
  "Après 6 ans d'infertilité, je suis enceinte. Miracle ou intervention spirituelle ? Je pense les deux.",
  "Ex-fumeur de 20 ans. Rituel de libération et je n'ai plus touché à une cigarette depuis 8 mois.",
  "Mon mari ne me trompe plus. Rituel puissant, effet immédiat.",
  "Un an après, je vis avec l'homme qui m'a quittée. On se marie l'été prochain. Merci Maître.",
  "Ses rituels agissent en profondeur, pas juste en surface. Résultats stables dans le temps.",
  "Ma santé s'est améliorée après des mois de fatigue inexpliquée. Il a détecté ce que les médecins ignoraient.",
  "Rapide, discret, humain. Trois qualités rares réunies chez un seul homme.",
  "Il m'a dit exactement ce qui se passait dans ma vie sans que je le lui dise. Impressionnant.",
  "Discrétion totale. Ma famille ne se doute de rien et pourtant tout va mieux depuis.",
  "Amitiés retrouvées, malentendus levés, cœurs apaisés. Un vrai artisan de l'harmonie.",
  "Suite à son intervention, mes créanciers me laissent respirer. Négociations débloquées.",
  "Trois années de célibat difficile. Depuis son rituel, deux prétendants sérieux à mes côtés.",
  "Il a sorti mon fils d'une mauvaise fréquentation. Sans conflit, en douceur, mais efficacement.",
  "Rêves lourds, cauchemars récurrents : plus rien depuis la purification de ma chambre.",
  "Il travaille avec la magie blanche, jamais avec de mauvaises intentions. C'est important.",
  "Rituel de séduction : je suis devenu magnétique, j'attire les regards sans effort.",
  "Ma promotion tant attendue est arrivée. Coïncidence ? Je ne crois pas.",
  "Un vrai marabout ne juge jamais. Maître Diamma écoute et agit, c'est tout.",
  "L'ambiance à la maison est méconnaissable. Enfants apaisés, couple soudé.",
  "Prise de contact gratuite : il a pris 20 minutes rien que pour m'écouter. Rare.",
  "J'ai récupéré ma femme après qu'elle soit partie avec un autre. Rituel très puissant.",
  "Enfin sortie d'une dépression qui durait depuis 4 ans. Nouvelle vie qui commence.",
  "Mon commerce ne désemplit pas depuis les rituels de prospérité. Clients fidèles et heureux.",
  "Il m'a dit la vérité, même quand ce n'était pas ce que je voulais entendre. Respect.",
  "Rituel réussi pour l'obtention de mon titre de séjour. Cette angoisse est terminée.",
  "Ma copine avait quelqu'un d'autre. Aujourd'hui elle m'aime plus qu'avant. Ancien monde balayé.",
  "Sur Whats'app, réponses rapides et personnalisées. Il n'y a pas de standard téléphonique.",
  "J'ai récupéré la maison familiale que je pensais perdue en justice. Décision favorable inespérée.",
  "Un baume au cœur, une main tendue quand on n'en peut plus. Merci pour tout Maître Diamma.",
  "Mon frère alcoolique a arrêté seul de boire après un rituel de libération. Miracle familial.",
  "Discussions apaisées avec mon ex pour la garde des enfants. Il m'a aidée à trouver la paix.",
  "Deuxième mariage : les rituels de mon premier mariage ont enfin été dénoués.",
  "Ma boutique en ligne cartonne depuis 3 mois. Les commandes affluent. Merci pour la prospérité.",
  "Rituel d'harmonie familiale : mes parents se parlent à nouveau après 10 ans de brouille.",
  "J'ai vu clair dans le jeu de mon associé grâce à sa voyance. J'ai pu me protéger à temps.",
  "Un bouclier de protection installé autour de mes enfants. Je dors sur mes deux oreilles.",
  "Ses réponses par Whats'app sont personnelles, jamais copiées-collées. On sent le vrai suivi.",
  "Retour affectif discret, sans qu'il ne le sache. Il m'aime de nouveau et pense que c'est spontané.",
  "Ma sœur jalouse ne me nuit plus. Le retour à l'envoyeur a été effectué en douceur.",
  "Cabinet accueillant, ambiance apaisante, on se sent à l'aise dès l'entrée.",
  "Aucun jugement, aucun discours moralisateur. Il traite chaque demande avec humilité.",
  "Il ne prend pas plus que ce qui est nécessaire. Honnête sur tous les plans.",
  "Trois ans d'attente pour un enfant. Deux mois après le rituel de fertilité, je suis enceinte.",
  "Puissance retrouvée après des années de doute. Ma vie sexuelle est épanouie à nouveau.",
  "Mon patron toxique a été muté sans que je ne demande rien. Coïncidence heureuse.",
  "Un homme humble, malgré ses dons extraordinaires. Ni orgueil, ni vantardise.",
  "Le sort qu'on m'avait jeté a été renvoyé. Je sens la légèreté enfin revenue.",
  "Rituel d'appel : le mec que j'aimais depuis 2 ans m'a enfin déclaré ses sentiments.",
  "Il agit vite mais toujours avec précision. Rien n'est laissé au hasard.",
  "Mes cauchemars ont disparu, je dors comme quand j'étais enfant. Précieux cadeau.",
  "Il m'a averti d'un danger. Il avait raison. J'ai évité un accident grave.",
  "Voyance téléphonique claire, sans questions pour deviner. Il sait, tout simplement.",
  "Réconciliation mère-fille après des années de silence. Larmes de joie retrouvées.",
  "Rituel de désenvoûtement puissant. J'ai vraiment senti quelque chose partir de moi.",
  "Il m'a expliqué que certaines choses prennent du temps. Honnêteté rare, résultats bien là.",
  "Une lumière dans mon obscurité. Sans lui je ne sais pas ce que je serais devenue.",
  "Ses rituels d'attraction financière fonctionnent. J'ai reçu deux paiements imprévus dans le mois.",
  "Il ne m'a pas fait de fausses promesses. Chaque parole a été tenue.",
  "Ma peau s'est apaisée après un soin. Problèmes dermatologiques enfin réglés.",
  "Rendez-vous à Orléans, cabinet propre et discret. Aucune pression commerciale.",
  "Mon ex a fait demi-tour et m'a supplié de reprendre. C'est incroyable mais c'est réel.",
  "Je pensais que c'était bidon, je suis venue par curiosité. Aujourd'hui je suis convaincue.",
  "Une vraie prise en charge, pas juste un rituel bâclé. Il suit vraiment ses consultants.",
  "Grâce à lui j'ai retrouvé une relation apaisée avec ma mère avant qu'elle ne parte. Précieux.",
  "Mon associé m'a été rendu honnête grâce à ses travaux. Business qui repart de zéro sain.",
  "L'homme dont j'étais folle a soudainement recommencé à me courtiser. Il n'y comprend rien.",
  "Rituel réussi pour l'achat de notre maison. Financement débloqué contre toute attente.",
  "Sa force calme est rassurante. On sent qu'il maîtrise ce qu'il fait.",
  "Je le recommande à toutes mes amies. Toutes m'ont remerciée par la suite.",
  "Il m'a aidée à quitter un homme qui me faisait du mal. Aujourd'hui je suis libre et heureuse.",
  "Mon compagnon distant est redevenu tendre et présent. Le rituel a agi doucement mais sûrement.",
  "Trois semaines après le rituel, j'ai retrouvé du travail. Poste de rêve, salaire idéal.",
  "Enfin les mauvaises langues se sont tues autour de moi. La protection fonctionne.",
  "Discussion honnête, sans fioritures. Il vous dit clairement s'il peut vous aider ou non.",
  "Ma vie amoureuse a totalement changé. Je suis épanouie comme jamais.",
  "Aucune impression d'être arnaquée. Tarifs clairs, travaux clairs, résultats clairs.",
  "Mon enfant hyperactif s'est apaisé après un soin. Nuits paisibles à la maison.",
  "Il travaille en accord avec la foi de chacun. Respect total de mes croyances.",
  "Un an de suivi pour un cas compliqué. Résultat au bout : mariage sauvé.",
  "Voyance mensuelle qui m'aide à prendre les bonnes décisions professionnelles.",
  "Rituel d'union scellée : plus aucune tentative extérieure ne menace notre couple.",
  "Une paix intérieure retrouvée après des années de tumulte. Merci merci merci.",
  "Il m'a dit ce que je devais entendre, quand je devais l'entendre. Vraie sagesse.",
  "Rituel réussi pour éloigner ma belle-famille toxique de notre foyer.",
  "Mon fils est revenu au domicile familial après 2 ans de fugue. Les mots me manquent.",
  "Prospérité retrouvée. Je vois enfin le bout du tunnel après des années de galère.",
  "Une intervention discrète qui a tout changé sans que personne ne s'en aperçoive.",
  "Grâce à sa protection, mon voyage à l'étranger s'est passé sans encombre.",
  "Résultat en 15 jours pour mon retour affectif. Il a été plus rapide que prévu.",
  "Une bienveillance qui fait chaud au cœur. Une vraie personne de confiance.",
  "Ses rituels d'harmonie m'ont réconciliée avec moi-même. Estime de soi retrouvée.",
  "Mon commerce était en perte constante. Trois mois après, bénéfices multipliés par 3.",
  "Rituel de séduction efficace : je plais enfin, sans forcer, avec naturel.",
  "Il m'a aidée à sortir des dettes. Prêt accordé après 6 refus successifs.",
  "Guérisseur véritable. Ma migraine chronique de 15 ans a disparu en une consultation.",
  "Une écoute qui apaise, des mots qui font du bien. Bien plus qu'un simple marabout.",
  "Prise en charge sérieuse, sans jamais me faire sentir bête ou naïve.",
  "Rituel de retour de l'être aimé effectué en un rendez-vous. Résultat après 12 jours.",
  "J'ai reçu des excuses sincères de la personne qui m'avait fait du mal. Justice spirituelle.",
  "Sa réputation n'est pas usurpée. Le bouche à oreille dit vrai à Orléans.",
  "Une réunion familiale organisée après 8 ans de silence. Cadeau inestimable.",
  "Depuis les rituels, plus une seule dispute majeure dans mon couple. La paix règne.",
  "J'ai retrouvé mon chien perdu grâce à ses conseils. Détails précis sur l'endroit.",
  "Consultation en visio parfaite pour moi qui suis loin. Résultat identique à un rendez-vous physique.",
  "Trois ans de blocage professionnel envolés. Reconnaissance de mon employeur enfin acquise.",
  "Rituel puissant, cabinet accueillant, homme respectueux. Trio parfait.",
  "Mes finances ont retrouvé un équilibre. Impayés remboursés, économies possibles.",
  "Il a soigné ma mère à distance. Son état s'est stabilisé de manière surprenante.",
  "J'ai enfin osé quitter un emploi qui me détruisait. Nouvelle vie professionnelle réussie.",
  "Aucune sensation de tomber dans une secte. Consultation saine et lucide.",
  "Ses conseils énergétiques sont d'une justesse admirable. Il voit ce que les autres ne voient pas."
];

const ilYA = [
  "il y a 2 jours","il y a 5 jours","il y a 1 semaine","il y a 2 semaines",
  "il y a 3 semaines","il y a 1 mois","il y a 2 mois","il y a 3 mois",
  "il y a 4 mois","il y a 5 mois","il y a 6 mois","il y a 8 mois",
  "il y a 10 mois","il y a 1 an","il y a 1 an","il y a 1 an"
];

function build() {
  const arr = [];
  for (let i = 0; i < 150; i++) {
    arr.push({
      id: `avis-${i + 1}`,
      nom: noms[i % noms.length],
      ville: villes[(i * 3) % villes.length],
      texte: textes[i % textes.length],
      note: 5,
      il_y_a: ilYA[(i * 7) % ilYA.length],
      initiale: noms[i % noms.length].charAt(0)
    });
  }
  return arr;
}

export const googleReviews = build();
export const noteMoyenne = 4.9;
export const nbAvis = 150;
